import { Drawer } from 'antd';
import styles from './CabinPickerSheet.module.css';

interface Cabin {
  id: string;
  name: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  cabins: Cabin[];
  selectedId: string;
  onSelect: (id: string) => void;
}

function CabinPickerSheet({ open, onClose, cabins, selectedId, onSelect }: Props) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="bottom"
      height="auto"
      title="选择舱室"
      styles={{
        body: { padding: '4px 0 env(safe-area-inset-bottom, 16px)' },
        header: {
          background: 'rgba(10, 22, 44, 0.98)',
          borderBottom: '1px solid rgba(0,255,255,0.12)',
          color: '#fff',
        },
        content: { background: 'rgba(10, 22, 44, 0.98)' },
      }}
      rootStyle={{ zIndex: 1100 }}
    >
      {cabins.map((cabin) => (
        <div
          key={cabin.id}
          className={`${styles.item} ${cabin.id === selectedId ? styles.itemActive : ''}`}
          onClick={() => onSelect(cabin.id)}
        >
          <span>{cabin.name}</span>
          {cabin.id === selectedId && <span className={styles.check}>✓</span>}
        </div>
      ))}
    </Drawer>
  );
}

export default CabinPickerSheet;
